export type PricingType =
  "BASE" | "BRONZE" | "SILVER" | "GOLD" | "CENTER" | "AGGRESSIVE";

export const PricingTypeEnum: Record<PricingType, PricingType> = {
  BASE: "BASE",
  BRONZE: "BRONZE",
  SILVER: "SILVER",
  GOLD: "GOLD",
  CENTER: "CENTER",
  AGGRESSIVE: "AGGRESSIVE",
};
